<div [ngClass]="buttonClasses() + ' ' + positionClasses() + (icon() ? ' with-icon' : '') + (label() ? ' with-label' : '')" (click)="onClick()">
  @if(badge() && badge()! > 0) {
    <ion-badge class="absolute -top-0 -right-0 w-5 h-5 flex items-center justify-center rounded-full text-xs leading-none z-10 bg-brand-500 font-medium font-title text-gray-700">
      {{ badge() }}
    </ion-badge>
  }
  @if(icon()) {
    <div >
      <lib-icon [name]="icon()!" class="text-gray-500 hover:text-gray-700 transition-colors"></lib-icon>
    </div>
  }
  @if(label()) {
    <span class="text-sm font-medium text-center">{{label()}}</span>
  }
</div>